module.exports = __webpack_public_path__ + "img/moderate.7b4201da.jpg";